// let basePath = '';
const version = '1.0.6';

const buildVersion = '1.6.0.5';
const environment = import.meta.env.VITE_CURRENT_PUBLIC_SERVER_TAG_TYPE

console.log('subscribeVersion:::', buildVersion);
let configUrl = null
if (environment === 'local') {
    configUrl = 'flexclip.config.js'
} else if (location.href.indexOf('www.flexclip.com')) {
    configUrl = 'flexclip.config.js'
}

export default {
    version,
    buildVersion,
    serverPath: environment !== 'release'
        ? 'https://www.smartvideomaker.com/'
        : 'https://www.flexclip.com/',
    requestPath: environment !== 'release'
        ? 'https://www.smartvideomaker.com'
        : 'https://www.flexclip.com',
    // languagePath: environment === 'local' ? `${basePath}language/local.` : `${basePath}media/login_panel/v1/language/local.`,
    languagePath: environment === 'local' ? `language/local.` : `/app/subscription/language/local.`,
    configUrl: configUrl
};
